var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v(" Créer facture ")]),_c('card',[_c('shared-create-internal-invoice',{on:{"created":_vm.onInvoiceCreate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }